import { fetcher } from '@commenda/utils';
import { useQuery } from '@tanstack/react-query';
import { CONNECTIONS_ROUTE, connectionsKeys } from './keys';
import { IUserConnection } from './types';

const getMyConnections = async (): Promise<IUserConnection[]> => {
  const response = await fetcher(CONNECTIONS_ROUTE, { method: 'GET' });

  if (!response.ok) throw new Error('Failed to load your connected apps');

  return (await response.json()) as IUserConnection[];
};

export const useMyConnections = () =>
  useQuery({
    queryKey: [connectionsKeys.MINE],
    queryFn: getMyConnections,
  });
